var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"lottie":""}},[(_vm.fallback && !_vm.loaded)?_c('img',{staticClass:"fallback",attrs:{"src":_vm.fallback,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }